import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7800d4ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"120px"} }
const _hoisted_2 = {
  key: 0,
  style: {"color":"var(--fcolor)"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "abs",
  style: {"left":"110px","top":"1px","color":"var(--el-input-text-color, var(--el-text-color-regular))"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-down" })
], -1))

import { ref, computed, reactive, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { useSite2Station } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { Site } from '@/common/const'
import { SearchLangType } from '@/common/search'


export default /*#__PURE__*/_defineComponent({
  props: {
    params: { type: null, required: false },
    search: { type: null, required: true },
    keyMap: { type: null, required: false }
  },
  setup(__props: any) {

const props = __props as {params?:any, search:any, keyMap?:any}
const route = useRoute()



const site = useSite2Station()

const langTypeOtions = [
  {
    value: {
      [Site.JA]: SearchLangType.JA, // 日语
      [Site.KO]: SearchLangType.KR, // 韩语
      [Site.EN]: SearchLangType.EN // 英语
    }[site],
    label: {
      [Site.JA]: '日本语入力',
      [Site.KO]: '한국어 입력',
      [Site.EN]: 'English'
    }[site]
  },
  {
    value: SearchLangType.ZH,
    label: t('请输入中文')
  }
]

const data = reactive(props.params ?? {})

// 默认选第一个
if (!data.langType) {
  data.langType = langTypeOtions[0].value
}

const searchRef = ref()

watch(() => route, () => {
  console.log(route.query?.keyword)
  route.query?.keyword && (data.keyword = route.query.keyword)
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, {
    class: "rel",
    ref: (_value, _refs) => {
      _refs['searchRef'] = _value
      searchRef.value = _value
    },
    placeholder: _unref(t)('请输入商品名称'),
    type: "text",
    maxlength: "500",
    modelValue: _unref(data).keyword,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).keyword) = $event)),
    title: _unref(data).keyword
  }, {
    prefix: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_select, {
          modelValue: _unref(data).langType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).langType) = $event)),
          size: "small",
          style: {"width":"100px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(langTypeOtions, (lang) => {
              return _createVNode(_component_el_option, {
                size: "sime",
                key: lang.value,
                label: lang.label,
                value: lang.value
              }, {
                default: _withCtx(() => [
                  (lang.value === _unref(data).langType)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(lang.label), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(lang.label), 1))
                ]),
                _: 2
              }, 1032, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_4
      ])
    ]),
    suffix: _withCtx(() => [
      _createElementVNode("div", {
        class: "flex-ter rel pl_10 searchIcon",
        style: {"height":"34px"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.search(_unref(data))))
      }, [
        _createVNode(SvgIcon, {
          style: {"font-size":"18px","color":"#fff","margin-left":"5px"},
          class: "btn rel",
          name: "搜索"
        })
      ])
    ]),
    _: 1
  }, 8, ["placeholder", "modelValue", "title"]))
}
}

})